import {
    SET_CONFLUENCE_DOCUMENT_LINKS,
    ConfluenceLinks,
} from "./information-links-types";

export const setConfluenceDocumentLinks = (
    confluenceDocumentLinks: ConfluenceLinks
) => ({
    type: SET_CONFLUENCE_DOCUMENT_LINKS,
    confluenceDocumentLinks: confluenceDocumentLinks,
});
